import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import VendorList, { DispatchProps, OwnProps, StateProps } from './VendorList';
import { StoreState } from 'src/store/reducers';
import { QueryParams } from 'src/types/grid';
import { getVendors } from 'src/store/actions/vendor-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        data: state.vendors.data,
        inProgress: state.vendors.inProgress,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (params: QueryParams) => dispatch(getVendors(params)),
    };
}

const VendorListScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(VendorList);

export default VendorListScreen;
